import React from 'react';
import Hls from 'hls.js';
import { Song } from './types';

interface AudioErrorDisplayProps {
  audioError: string | null;
  detailedError: string | null;
  songUrl: string | null;
  currentSong: Song | null;
  setupNativeHlsPlayback: (hlsUrl: string, autoPlay: boolean) => void;
  setupHlsPlayback: (hlsUrl: string, autoPlay: boolean) => void;
  browserInfo: string | null;
}

const AudioErrorDisplay: React.FC<AudioErrorDisplayProps> = ({
  audioError,
  detailedError,
  songUrl,
  currentSong,
  setupNativeHlsPlayback,
  setupHlsPlayback,
  browserInfo
}) => {
  if (!audioError) return null;

  return (
    <div className="bg-red-700 text-white p-2 mb-2 text-sm">
      <div className="font-bold">Audio Error: {audioError}</div>
      {detailedError && (
        <div className="mt-1 text-xs">
          Details: {detailedError}
        </div>
      )}
      <div className="mt-1 text-xs">
        Current source: {songUrl || currentSong?.hlsUrl || 'No URL available'}
      </div>
      <div className="mt-1 text-xs">
        HLS.js supported: {Hls.isSupported() ? 'Yes' : 'No'}
      </div>
      <div className="mt-1 text-xs">
        Native HLS supported: {document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '' ? 'Yes' : 'No'}
      </div>
      <div className="mt-1 text-xs">
        Browser: {browserInfo || navigator.userAgent}
      </div>
      <div className="flex space-x-2 mt-2">
        <button 
          onClick={() => {
            if (currentSong?.hlsUrl) {
              setupNativeHlsPlayback(currentSong.hlsUrl, true);
            }
          }}
          className="px-2 py-0.5 bg-white text-red-700 text-xs"
        >
          Try Native HLS
        </button>
        <button 
          onClick={() => {
            if (currentSong?.hlsUrl) {
              setupHlsPlayback(currentSong.hlsUrl, true);
            }
          }}
          className="px-2 py-0.5 bg-gray-200 text-gray-800 text-xs"
        >
          Try HLS.js
        </button>
        <button 
          onClick={() => {
            const audio = document.createElement('audio');
            // Debug audio format support
          }}
          className="px-2 py-0.5 bg-blue-500 text-white text-xs"
        >
          Debug Support
        </button>
      </div>
    </div>
  );
};

export default AudioErrorDisplay; 